import router from "@/router";
import { getUserDelegation, getUserDelegationOrch,saveUserDelegation, searchDelegationList } from "@/store/services/configuration/DelegationService";
import { DelegationState } from "@/types";
import { Module } from "vuex";


const DelegationModule: Module<DelegationState, unknown> = {
    namespaced: true,
    state:{
        delegationSelected : {}
    },
    getters:{
        getdelegationSelectedInit(){
            return {
                objectType: "odm.user.delegation",
                systemUid: "odm-user",
                resourceUid: "",
                userDelegatedFrom: {
                  objectType: "odm.user.leaseforgeuser",
                  systemUid: "odm-user",
                  resourceUid: "",
                  rawData: {},
                  config: {}
                },
                userDelegatedTo: {
                  objectType: "odm.user.leaseforgeuser",
                  systemUid: "odm-user",
                  resourceUid: "",
                  rawData: {}
                },
                networkNode: {
                  objectType: "odm.party.networknode",
                  systemUid: "odm-party",
                  resourceUid: "",
                  rawData: {}
                },
                validity: {
                  from: "",
                  until: ""
                }
              }
        }
    },
    actions:{
        searchDelegationList({ commit }, payload) {
                const { filter,offset,limit, callback } = payload;
                searchDelegationList(filter,offset,limit)
                  .then((res) => {
                    callback(res);
                  })
                  .catch((e) => console.error(e));
        },
        async getUserDelegation({ commit }, payload){
              const userOrch = await getUserDelegation(payload)
              commit("setUserDelegation", userOrch)

        },
        async saveUserDelegation({ commit }, payload){
            const userOrch = await saveUserDelegation(payload)
            const getUserOrch = await getUserDelegation(userOrch.resourceUid)
            commit("setUserDelegation", getUserOrch)

      },
        initUserDelegation({ commit },payload){
            const delegatIonInt = this.getters["DelegationModule/getdelegationSelectedInit"]
            commit("setUserDelegation", delegatIonInt)
            router.push("/delegation/edit");  
            },
    },
    mutations:{
        setUserDelegation(state, payload) {
            state.delegationSelected = payload
          },
    }
};
export default DelegationModule;